import { render, staticRenderFns } from "./NewUiWelcomeBanner.vue?vue&type=template&id=47c44af2&scoped=true"
import script from "./NewUiWelcomeBanner.vue?vue&type=script&lang=js"
export * from "./NewUiWelcomeBanner.vue?vue&type=script&lang=js"
import style0 from "./NewUiWelcomeBanner.vue?vue&type=style&index=0&id=47c44af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c44af2",
  null
  
)

export default component.exports